import AddResearcherDialog from './AddResearcherDialog';

export default AddResearcherDialog;